import { USERS_COLLECTION } from "../../constants/collections";
import { Config, StatusOption } from "./config";
// todo add error boundary

const ROLES = {
  ADMIN: "admin",
  MECHANIC: "mechanic",
  ELECTRICIAN: "electrician",
  WHEEL_ALIGNMENT: "wheelAlignment",
  ENGINE_MECHANIC: "engineMechanic",
  TIRE_SERVICE: "tireService",
  GENERATOR: "generator_starter",
  STO: "STO",
};

const appAccessRoles = [ROLES.ADMIN, ROLES.MECHANIC];

const optionRoles = [
  ROLES.MECHANIC,
  ROLES.ELECTRICIAN,
  ROLES.WHEEL_ALIGNMENT,
  ROLES.ENGINE_MECHANIC,
  ROLES.TIRE_SERVICE,
  ROLES.GENERATOR,
  ROLES.STO,
];

const STATUS_OPTIONS: StatusOption[] = [
  {
    value: "Incoming",
    editableBy: appAccessRoles,
    visibleBy: appAccessRoles,
  },
  {
    value: "Completed",
    editableBy: [ROLES.ADMIN],
    visibleBy: [ROLES.ADMIN],
  },
];

const STATUS_COLORS: Record<string, string> = {
  Incoming: "#dc2626",
  Completed: "#16a34a",
};

const STO: Config = {
  appName: "AutoRepairPro",
  mainCollection: "repair-orders",
  theme: {
    primaryColor: "#2c3e50",
    secondaryColor: "#e74c3c",
  },
  defaultRole: ROLES.MECHANIC,
  roles: appAccessRoles,
  statuses: ["Incoming", "Completed"],
  screens: [
    {
      name: "RepairOrdersBoard",
      type: "board",
      collection: "repair_orders",
      roles: [ROLES.ADMIN, ROLES.MECHANIC],
      defaultPresentation: "horizontal",
      statusOptions: STATUS_OPTIONS,
      statusColors: STATUS_COLORS,
      filters: [
        {
          field: "dateCreated",
          type: "date",
          label: "По дате",
        },
      ],
    },
    {
      name: "MechanicsList",
      type: "list",
      collection: "mechanics",
      roles: [ROLES.ADMIN],
      icon: "account-hard-hat",
      presentation: "table",
    },
    {
      name: "CustomersList",
      type: "list",
      collection: "customers",
      roles: [ROLES.ADMIN],
      icon: "account-multiple",
      presentation: "table",
      filters: [
        {
          field: "fullName",
          type: "search",
          label: "Поиск клиентов",
          searchTermKeys: ["fullName", "phone", "email"],
        },
      ],
    },
    {
      name: "VehiclesList",
      type: "list",
      collection: "vehicles",
      roles: [ROLES.ADMIN],
      icon: "car",
      presentation: "table",
      filters: [
        {
          field: "licensePlate",
          type: "search",
          label: "by car number",
          searchTermKeys: ["licensePlate", "model"],
        },
        {
          field: "createdAt",
          type: "date",
          label: "По дате",
        },
      ],
    },
    {
      name: "ServicesList",
      type: "list",
      collection: "repair_services",
      roles: [ROLES.ADMIN],
      icon: "tools",
      presentation: "table",
      orderBy: [{ field: "name", direction: "asc" }],
    },
    {
      name: "InventoryList",
      type: "list",
      collection: "inventory",
      roles: [ROLES.ADMIN],
      presentation: "table",
      icon: "package-variant",
    },
    {
      name: "ExpensesList",
      type: "list",
      collection: "expenses",
      roles: [ROLES.ADMIN],
      icon: "cash-minus",
      presentation: "table",
      weekNavigation: {
        field: "date",
      },
      orderBy: [{ field: "date", direction: "desc" }],
      filters: [
        {
          field: "date",
          type: "date",
          label: "По дате",
        },
        {
          field: "text",
          type: "search",
          label: "Поиск расходов",
          searchTermKeys: ["text"],
        },
      ],
    },
    {
      name: "STOReportsScreen",
      type: "reports",
      collection: "repair_orders",
      roles: [ROLES.ADMIN],
    },
    {
      name: "WeeklyReportsList",
      type: "list",
      collection: "stoWeeklyReport",
      roles: [ROLES.ADMIN],
      icon: "file-document",
      presentation: "table",
      orderBy: [{ field: "weekStart", direction: "desc" }],
    },
    {
      name: "MakesList",
      type: "list",
      collection: "makes",
      roles: [ROLES.ADMIN],
      icon: "car",
      presentation: "table",
      filters: [
        {
          field: "name",
          type: "search",
          label: "Search Makes",
          searchTermKeys: ["name"],
        },
      ],
    },
    {
      name: "ModelsList",
      type: "list",
      collection: "models",
      roles: [ROLES.ADMIN],
      icon: "car-info",
      presentation: "table",
      orderBy: [
        { field: "make.name", direction: "asc" },
        { field: "name", direction: "asc" },
      ],
      filters: [
        {
          field: "name",
          type: "search",
          label: "Search Models",
          searchTermKeys: ["name"],
        },
      ],
    },
    // {
    //   name: "CustomerChat",
    //   type: "chat",
    //   collection: "customer_chats",
    //   roles: [ROLES.ADMIN],
    // },
    {
      name: "DriveScreen",
      type: "drive",
      collection: "drive_files",
      icon: "folder-outline",
      roles: appAccessRoles,
    },
  ],
  database: [
    {
      name: "mechanics",
      fields: [
        {
          name: "fullName",
          type: "text",
          label: "Full Name",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
        },
        {
          name: "phone",
          type: "phone",
          label: "Phone Number",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
        },
        {
          name: "email",
          type: "text",
          label: "Email",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: false,
        },
        {
          name: "role",
          type: "dropdown",
          label: "Role",
          options: optionRoles,
          required: true,
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
      ],
    },
    {
      name: "repair_orders",
      uniqIdNumber: true,
      fields: [
        {
          name: "archived",
          type: "booleanCheckbox",
          label: "Archived",
          defaultValue: false,
          list: [],
          form: [],
          board: [],
        },
        {
          name: "numberId",
          type: "numberId",
          label: "Order Number",
          list: [],
          form: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [],
          width: 0.3,
        },
        {
          name: "status",
          type: "dropdown",
          options: ["Incoming", "Completed"],
          label: "Status",
          defaultValue: "Incoming",
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          formCreate: [],
          formEdit: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [],
        },
        {
          name: "dateCreated",
          type: "dateTime",
          label: "dateCreated",
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          formEdit: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [ROLES.ADMIN, ROLES.MECHANIC],
        },
        {
          name: "statusChangedAt",
          type: "dateTime",
          label: "Время изменения статуса",
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [ROLES.ADMIN, ROLES.MECHANIC],
        },
        {
          name: "vehicle",
          type: "collectionPicker",
          collection: "vehicles",
          label: "Vehicle",
          key: "licensePlate",
          secondKey: "make.name",
          thirdKey: "model.name",
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          form: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [ROLES.ADMIN, ROLES.MECHANIC],
          required: true,
        },
        {
          name: "mechanics",
          type: "mechanicPicker",
          label: "Services",
          collection: "mechanics",
          key: "fullName",
          relatedObject: {
            countTotal: true,
            formula:
              "contextData.reduce((sum, current) => sum + parseInt(current.price), 0)",
            collection: "repair_services",
            key: "name",
            secondKey: "price",
            multiselect: true,
            where: [
              {
                field: "roles",
                operator: "array-contains",
                value: "role",
                from: "formData",
              },
            ],
          },
          // collection: "repair_services",
          // secondKey: "role",
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          form: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [ROLES.ADMIN, ROLES.MECHANIC],
          required: true,
        },
        {
          name: "parts",
          type: "testPicker",
          label: "Parts",
          collection: "mechanics",
          key: "fullName",
          // secondKey: "role",
          relatedObject: {
            formula:
              "contextData.reduce((sum, current) => sum + parseInt(current.price), 0)",
            collection: "inventory",
            key: "name",
            secondKey: "price",
            multiselect: true,
          },
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          form: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [ROLES.ADMIN, ROLES.MECHANIC],
        },
        {
          name: "totalPrice",
          type: "calculated",
          label: "Total Price",
          calculation: {
            formula:
              "(mechanics || []).reduce((sum, item) => sum + ((item?.relatedObjectField || []).reduce((s, el) => s + (parseFloat(el?.price) || 0), 0)), 0) + (parts || []).reduce((sum, item) => sum + ((item?.relatedObjectField || []).reduce((s, el) => s + (parseFloat(el?.price) || 0), 0)), 0)",
            dependencies: ["mechanics", "parts"],
          },
          form: [ROLES.ADMIN, ROLES.MECHANIC],
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [ROLES.ADMIN, ROLES.MECHANIC],
        },
        // {
        //   name: "mechanic",
        //   type: "collectionPicker",
        //   collection: "mechanics",
        //   label: "Mechanic",
        //   key: "fullName",
        //   list: ["admin"],
        //   form: ["admin"],
        //   board: ["admin"],
        //   required: true,
        // },
        {
          name: "payments",
          type: "paymentsForm",
          options: ["cash", "halyk", "kaspi"],
          label: "Payments",
          list: [],
          form: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [],
          required: true,
        },
        {
          name: "unpaidAmount",
          type: "calculated",
          label: "Remaining Amount",
          calculation: {
            formula:
              "Number(totalPrice[0]) - payments.reduce((sum, p) => sum + Number(p.paymentAmount), 0)",
            dependencies: ["totalPrice", "payments"],
          },
          form: [ROLES.ADMIN, ROLES.MECHANIC],
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [ROLES.ADMIN, ROLES.MECHANIC],
        },
        {
          name: "notes",
          type: "textarea",
          label: "Notes",
          list: [ROLES.ADMIN, ROLES.MECHANIC],
          form: [ROLES.ADMIN, ROLES.MECHANIC],
          board: [],
        },
      ],
    },
    {
      name: "payments",
      fields: [
        {
          name: "paymentType",
          type: "dropdown",
          options: ["cash", "halyk", "kaspi"],
          label: "Payment Method",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
        {
          name: "paymentAmount",
          type: "number",
          label: "paymentAmount",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
      ],
    },
    {
      name: "customers",
      fields: [
        {
          name: "fullName",
          type: "text",
          label: "Full Name",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
        },
        {
          name: "phone",
          type: "phone",
          label: "Phone Number",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
        },
        {
          name: "email",
          type: "text",
          label: "Email",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
        {
          name: "address",
          type: "text",
          label: "Address",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
      ],
    },
    {
      name: "vehicles",
      fields: [
        {
          name: "make",
          type: "collectionPicker",
          collection: "makes",
          label: "Make",
          key: "name",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
          autoCapitalize: "characters",
        },
        {
          name: "model",
          type: "collectionPicker",
          collection: "models",
          label: "Model",
          key: "name",
          secondKey: "make.name",
          clientFilter: "modelsBySelectedMake",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
          autoCapitalize: "characters",
        },
        {
          name: "licensePlate",
          type: "text",
          label: "License Plate",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
          autoCapitalize: "characters",
        },
        {
          name: "year",
          type: "text",
          label: "Year",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: false,
        },
        {
          name: "vin",
          type: "text",
          label: "VIN",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
        {
          name: "owner",
          type: "collectionPicker",
          collection: "customers",
          label: "Owner",
          key: "fullName",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
      ],
    },
    {
      name: "repair_services",
      fields: [
        {
          name: "name",
          type: "text",
          label: "Service Name",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
        },
        {
          name: "description",
          type: "textarea",
          label: "Description",
          list: [],
          form: [ROLES.ADMIN],
          board: [],
        },
        {
          name: "price",
          type: "number",
          label: "Price",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
          width: 0.4,
        },
        {
          name: "duration",
          type: "number",
          label: "Duration (hours)",
          list: [],
          form: [ROLES.ADMIN],
          board: [],
        },
        {
          name: "roles",
          type: "dropdown",
          label: "Roles",
          multiselect: true,
          options: optionRoles,
          required: true,
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
      ],
    },
    {
      name: "inventory",
      fields: [
        {
          name: "name",
          type: "text",
          label: "Part Name",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
        },
        {
          name: "description",
          type: "textarea",
          label: "Description",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
        {
          name: "price",
          type: "number",
          label: "Price",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
        },
        {
          name: "quantity",
          type: "number",
          label: "Quantity in Stock",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
        },
        {
          name: "location",
          type: "text",
          label: "Storage Location",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
        },
      ],
    },
    {
      name: "expenses",
      uniqIdNumber: true,
      fields: [
        {
          name: "numberId",
          type: "numberId",
          label: "#",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [ROLES.ADMIN],
          width: 0.3,
        },
        {
          name: "date",
          type: "datePicker",
          label: "Date",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [ROLES.ADMIN],
          required: true,
        },
        {
          name: "text",
          type: "text",
          label: "Description",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [ROLES.ADMIN],
          required: true,
        },
        {
          name: "amount",
          type: "number",
          label: "Amount",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [ROLES.ADMIN],
          required: true,
        },
      ],
    },
    {
      name: "stoWeeklyReport",
      fields: [
        {
          name: "companyId",
          type: "text",
          label: "Company ID",
          list: [],
          form: [],
          board: [],
        },
        {
          name: "weekStart",
          type: "dateTime",
          label: "Week Start",
          list: [ROLES.ADMIN],
          form: [],
          board: [],
        },
        {
          name: "weekEnd",
          type: "dateTime",
          label: "Week End",
          list: [],
          form: [],
          board: [],
        },
        {
          name: "previousCumulativeProfit",
          type: "number",
          label: "Previous Cumulative Profit",
          list: [ROLES.ADMIN],
          form: [],
          board: [],
        },
        {
          name: "earning",
          type: "number",
          label: "Earning",
          list: [ROLES.ADMIN],
          form: [],
          board: [],
        },
        {
          name: "expenses",
          type: "number",
          label: "Expenses",
          list: [ROLES.ADMIN],
          form: [],
          board: [],
        },
        {
          name: "profit",
          type: "number",
          label: "Profit",
          list: [ROLES.ADMIN],
          form: [],
          board: [],
        },
        {
          name: "createdAt",
          type: "dateTime",
          label: "Created At",
          list: [ROLES.ADMIN],
          form: [],
          board: [],
        },
      ],
    },
    {
      name: USERS_COLLECTION,
      fields: [
        {
          name: "role",
          type: "dropdown",
          label: "Role",
          options: appAccessRoles,
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [ROLES.ADMIN],
        },
        {
          name: "email",
          type: "text",
          label: "Email",
          readOnly: true,
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [ROLES.ADMIN],
        },
        {
          name: "avatarUrl",
          type: "url",
          label: "Avatar",
          readOnly: true,
          list: [],
          form: [],
          board: [],
        },
        {
          name: "fullName",
          type: "text",
          label: "Full name",
          readOnly: true,
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [ROLES.ADMIN],
        },
      ],
    },
    {
      name: "models",
      fields: [
        {
          name: "make",
          type: "collectionPicker",
          collection: "makes",
          label: "Make",
          key: "name",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
          autoCapitalize: "characters",
        },
        {
          name: "name",
          type: "text",
          label: "Model",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
          autoCapitalize: "characters",
        },
      ],
    },
    {
      name: "makes",
      fields: [
        {
          name: "name",
          type: "text",
          label: "Make Name",
          list: [ROLES.ADMIN],
          form: [ROLES.ADMIN],
          board: [],
          required: true,
          autoCapitalize: "characters",
        },
      ],
    },
  ],
};

export default STO;
